import React, { useContext } from 'react';
import { SystemContext } from '../contexts/SystemContext';
import { UploadContext } from '../contexts/UploadContext';
import MODES from '../types/Modes';
import Button from './common/Button';
var UploadProgress = function () {
    var _a = useContext(UploadContext), progress = _a.progress, error = _a.error, success = _a.success, uploadFile = _a.uploadFile, clearState = _a.clearState;
    var setMode = useContext(SystemContext).setMode;
    return (React.createElement(React.Fragment, null,
        !error && React.createElement(React.Fragment, null,
            React.createElement("div", { className: "flex justify-center items-center mt-3" }, "We're currently uploading your video to Vimeo and adding it to Sanity."),
            React.createElement("div", { className: "flex justify-center text-lg" },
                "Progress: ",
                progress.toFixed(2),
                " %")),
        success && React.createElement(React.Fragment, null,
            React.createElement("div", { className: "flex justify-center items-center mt-3" }, "Upload complete!"),
            React.createElement("div", { className: "flex justify-center" },
                React.createElement(Button, { onClick: function () {
                        clearState();
                        setMode(MODES.BROWSING);
                    } }, "Go back"))),
        error &&
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: "flex justify-center items-center mt-3" }, "Something wnet wrong when uploading... Try again"),
                React.createElement("div", { className: "flex justify-center" },
                    React.createElement(Button, { onClick: uploadFile }, "Try again")))));
};
export default UploadProgress;
